<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner [diameter]="40" [strokeWidth]="5"></mat-spinner>
</div>
<section>
  <div class="result-section">
    <h3 class="heading">{{ 'RESULTS' | translate }}</h3>
    <hr class="rule" />

    <div class="action-bar">
      <button class="action-btn" (click)="goToNewSearch()">{{ 'NEW_SEARCH' | translate}}</button>
      <!--<button class="action-btn" (click)="openEmailFaxDialog()">
        {{'EMAIL' |translate}}/{{'FAX' | translate}}
      </button>-->
    </div>

    <table mat-table [dataSource]="dataSource" aria-describedby="" class="paginated-table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{width:'5%'}">
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" color="primary">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" color="primary">
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- customerAccount Column -->
      <ng-container matColumnDef="customerAccount">
        <th mat-header-cell *matHeaderCellDef (click)="sortData('customerAccount')">
          <span class="sort-header">{{'CUST_ACCOUNT' | translate}}</span>
          <span *ngIf="currentSortColumn === 'customerAccount'">
            {{ sortDirection === 'asc' ? '&#x25B2;' : '&#x25BC;' }}
          </span>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.customerAccount }}
        </td>
      </ng-container>

      <!-- invoiceNumber Column -->
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef (click)="sortData('invoiceNumber')">
          <span class="sort-header">{{'INVOICE_NO' | translate}}</span>
          <span *ngIf="currentSortColumn === 'invoiceNumber'">
            {{ sortDirection === 'asc' ? '&#x25B2;' : '&#x25BC;' }}
          </span>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceNumber }}</td>
      </ng-container>

      <!-- invoiceDate Column -->
      <ng-container matColumnDef="invoiceDate">
        <th mat-header-cell *matHeaderCellDef (click)="sortData('invoiceDate')">
          <span class="sort-header">{{'INVOICE_DATE' | translate}}</span>
          <span *ngIf="currentSortColumn === 'invoiceDate'">
            {{ sortDirection === 'asc' ? '&#x25B2;' : '&#x25BC;' }}
          </span>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.invoiceDate }}</td>
      </ng-container>

      <!-- invoiceAmount Column -->
      <ng-container matColumnDef="invoiceAmount">
        <th mat-header-cell *matHeaderCellDef (click)="sortData('invoiceAmount')" [ngStyle]="{ textAlign: 'right', width:'13%'}">
          <span class="sort-header">{{'INVOICE_AMOUNT' | translate}}</span>
          <span *ngIf="currentSortColumn === 'invoiceAmount'">
            {{ sortDirection === 'asc' ? '&#x25B2;' : '&#x25BC;' }}
          </span>
        </th>
        <td class="text-end" mat-cell *matCellDef="let element" [ngStyle]="{ textAlign: 'right' }">
          {{ element.invoiceAmount | currency}}
        </td>
      </ng-container>

      <!-- imageLink Column -->
      <ng-container matColumnDef="invoicePdf">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{ textAlign: 'center' }">{{'INVOICE_PDF' | translate}}</th>
        <td mat-cell *matCellDef="let element" [ngStyle]="{ textAlign: 'center' }">
          <img alt="pdf" (click)="openPDF(element.invoicePdf)" src="assets/images/pdf.svg" style="cursor: pointer" />
        </td>
      </ng-container>

      <!-- pins list Column -->
      <ng-container matColumnDef="listPins">
        <th mat-header-cell *matHeaderCellDef>{{'PINS' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <img alt="pins" (click)="
              displayList(
                element.customerAccount,
                element.invoiceNumber,
                element.invoiceDate
              )
            " src="assets/images/pins.svg" style="cursor: pointer" />
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
      <div class="data-not-found" *ngIf="message">{{'NO_DATA_FOUND' | translate }}</div>
      <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)" showFirstLastButtons aria-label="Select page of periodic elements">
      </mat-paginator>
  </div>
</section>
